// UI-only KPI card for the admin dashboard. No data fetching.
import type { ReactElement, ReactNode } from 'react';
import { Card, Typography } from 'antd';

const { Text } = Typography;

export interface OverviewStatCardProps {
  /** Translated metric name (uppercase label per the type scale). */
  label: string;
  /** Pre-formatted value (numbers formatted by the caller). */
  value: ReactNode;
  /** Optional secondary line, e.g. "+N за 24 часа". */
  hint?: string;
  /** data-testid for the card root. */
  testId?: string;
}

export function OverviewStatCard({
  label,
  value,
  hint,
  testId,
}: OverviewStatCardProps): ReactElement {
  return (
    <Card size="small" data-testid={testId} styles={{ body: { padding: 16 } }}>
      <Text
        className="block text-[11px] font-medium uppercase tracking-widest"
        style={{ color: 'var(--ant-color-text-secondary, #57534e)' }}
      >
        {label}
      </Text>
      <div className="mt-1.5 text-[22px] font-semibold leading-tight text-[var(--ant-color-text,#2d2418)]">
        {value}
      </div>
      {hint ? (
        <Text className="mt-1 block text-xs" style={{ color: 'var(--ant-color-text-tertiary)' }}>
          {hint}
        </Text>
      ) : null}
    </Card>
  );
}
